export default {
  // CRM
  'crm.partner.license': 'isc/partner/info', // 公司信息/合作伙伴 认证-营业执照
  'crm.id.face': 'isc/person/id', // 公司信息/合作伙伴 认证-身份证人像面
  'crm.id.reverse': 'isc/person/id', // 公司信息/合作伙伴 认证-身份证国徽面
  'crm.partner.authCert': 'isc/partner/info', // 公司信息 授权证书模板
  'crm.partner.seal': 'isc/partner/info', // 公司印章 印章图片
  'crm.contract': 'isc/contract/YYYYMM', // 合同公共 纸质合同上传  年月：YYYYMM
  // asm
  'asm.service.request': 'isc/service/request/YYYYMM', // 添加案例（组件）/工单管理-不在线设备 上传故障图片 添加服务单图片案例附件 年月：YYYYMM
  'asm.service.item.icon': 'isc/service/item', // 维修/保养项目管理-新增
  'asm.service.item.atlas': 'isc/service/item', // 维修/保养项目管理-新增
  'asm.part.icon': 'isc/icon/part', // 零件基础管理-创建零件 零件图片
  'dms.disposal.customer': 'isc/service/proposal', // 工单管理-案例订单-维修处理方案 客户处理附件/方案  事件代码/新增,编辑事件代码 客户处理附件
  'dms.disposal.technician': 'isc/service/proposal', // 工单管理-案例订单-维修处理方案 售后处理附件/方案 事件代码/新增,编辑事件代码 售后处理附件
  'dms.event.icon': 'isc/icon/event', // 事件代码/新增,编辑事件代码 事件主图
  // iot
  'iot.firmware': 'ist/firmware', // 资源管理/资源详情 资源路径-固件
  'iot.logs': 'ist/logs', // 资源管理/资源详情 资源路径-日志
  'iot.voice': 'ist/voice', // 资源管理/资源详情 资源路径-语音包
  'iot.protocol': 'ist/protocol', // 资源管理/资源详情 资源路径-协议
  'e': 'ist/map/data', // 环境地图
  'r': 'ist/map/data', //  路径地图
  'c': 'ist/map/data', //  配置地图
  'i': 'ist/map/data', //  缩略图
  't': 'ist/map/runs/YYYYMMDD', //  教学图 年月日：YYYYMMDD
  'w': 'ist/map/runs/YYYYMMDD', //  运行图 年月日：YYYYMMDD
  // dms
  'dms.product.doc': 'isc/product', // 产品管理/产品详情 文档
  'dms.product.icon': 'isc/product', // 产品管理/产品详情 主图
  'dms.product.atlas': 'isc/product', // 产品管理/产品详情 相册
  'asm.service.part.old': 'isc/service/part/YYYYMM', // 库存管理/零件更换 旧零件照片 零件更换 上传零件更换前图片 年月：YYYYMM
  'asm.service.part.new': 'isc/service/part/YYYYMM', // 库存管理/零件更换 新零件照片 零件更换 上传零件更换后图片 年月：YYYYMM
  'iot.component.icon': 'isc/icon/component', // 产品管理/产品详情/部件详情 图标编辑功能
  // fms
  'fms.trade.certificate': 'isc/trade/certificate/YYYYMM', // 应收管理/components/添加收款信息 应付管理/components/添加付款信息 交易凭证
  // training
  'tms.home.slide': 'isc/training/home', // 产品指南/新增编辑产品指南 首页展示
  'tms.home.video': 'isc/training/home', // 产品指南/新增编辑产品指南 首页视频
  'tms.icon': 'isc/training/product', // 产品指南/新增编辑产品指南/新增编辑视频节点 教程封面
  'tms.video': 'isc/training/product', // 产品指南/新增编辑产品指南/新增编辑视频节点 上传视频
  // h5 小程序 ice-APP
  'asm.feedback.customer': 'isc/service/feedback/YYYYMM', //  现场解除故障 上传维修反馈图片  年月：YYYYMM
  'asm.feedback.service': 'isc/service/feedback/YYYYMM', // 现场解除故障 上传维修描述图片  年月：YYYYMM
  'asm.maintenance.before': 'isc/upkeep/feedback/YYYYMM', // 保养工单完成提交 上传保养前图片  年月：YYYYMM
  'asm.maintenance.after': 'isc/upkeep/feedback/YYYYMM', // 保养工单完成提交 上传保养后图片  年月：YYYYMM


};
